import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { Button } from "@mui/material";

const JobRetranscodeButton: React.FC<{ ids: string[] }> = ({ ids }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleReTranscodeJob = () => {
    navigate("/jobs/retranscode", { state: { from: location.pathname, ids: ids } });
  };

  return (
    <Button size="small" variant="contained" disabled={!ids.length} onClick={handleReTranscodeJob}>
      Re-Transcode
    </Button>
  );
};

export default JobRetranscodeButton;
